const roundFilter = ( value: any, toFixed: number ) => {
    let result = '';
    if (value !== undefined) {
        result = Number(value).toFixed(toFixed);
        const splittedResult = result.split('.');
        if ( Number(splittedResult[1]) === 0) {
            result = splittedResult[0];
        }
    }
    return result;
};

export default roundFilter;
